import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import AnalyticsCard from './AnalyticsCard';

const COLORS = ['#0066cc','#4fb4cf','#10b981','#f59e0b','#ef4444','#6366f1','#f97316','#3b82f6','#8b5cf6','#ec4899','#0ea5e9','#84cc16','#14b8a6','#a855f7','#64748b'];

export default function ModelDistribution({ data }) {
  return (
    <AnalyticsCard title="Top 15 Vehicle Models">
      <ResponsiveContainer width="100%" height={280}>
        <BarChart data={data} layout="vertical" margin={{ top: 0, right: 16, left: 4, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="#e5e7eb" />
          <XAxis type="number" tick={{ fontSize: 10, fill: '#7e848c' }} />
          <YAxis dataKey="model" type="category" tick={{ fontSize: 10, fill: '#1e2125' }} width={80} />
          <Tooltip formatter={(v) => [v.toLocaleString(), 'Claims']} />
          <Bar dataKey="count" name="Claims" radius={[0, 3, 3, 0]}>
            {data.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </AnalyticsCard>
  );
}
